import { RootState } from 'store';

import {
  checkIsLoadingDone,
  checkIsLoading
} from 'common/utils/checkLoading';

import { useSelector } from 'react-redux';

import { STATIONS_STATE } from '../../constants';
import { EMPTY_ARRAY } from 'shared/constants';

export const useFilteredStations = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].filteredStations.data)
);

export const useAmountFilteredStations = () => {
  const filteredStations = useFilteredStations() || EMPTY_ARRAY;
  return filteredStations?.length;
};

export const useStationsFilter = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].filteredStations.filter)
);

export const useFilteredStationsLoadingStatus = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].filteredStations.loadingStatus)
);

export const useIsFilteredStationsDone = () => {
  const filteredStationsLoadingStatus = useFilteredStationsLoadingStatus();
  return checkIsLoadingDone(filteredStationsLoadingStatus);
};

export const useIsFilteredStationsLoading = () => {
  const filteredStationsLoadingStatus = useFilteredStationsLoadingStatus();
  return checkIsLoading(filteredStationsLoadingStatus);
};
